import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import AresNavBar from '../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';
import DataTableExtensions from 'react-data-table-component-extensions';
import client from "../../services/Api";
import moment from 'moment';

import './index.css'

function AccountUsers() {
    const [loading, setLoading] = useState(true);
    const [beacons, setBeacons] = useState([]);
    const [tableData, setTableData] = useState(null);

    const query = new URLSearchParams(window.location.search);
    const client_id = query.get('id');

    useEffect(() => {
        init()
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const columns = [
        {
            name: 'Nome',
            selector: 'name',
            sortable: false,
            width: '15%',
        },
        {
            name: 'Data de criação',
            format: row => moment.utc(row.created_at).local().format('DD/MM/YYYY HH:mm:ss'),
            selector: 'created_at',
            sortable: false,
            width: '12%',
        },
        {
            name: 'Dispositivos vinculados',
            selector: 'available_devices',
            format: row => row.available_devices != null ? row.available_devices.length : "--",
            sortable: false,
            width: '12%',
        },
    ];

    const customStyles = {
        rows: {
            style: {
                '&:hover': {
                    backgroundColor: '#03989E',
                    color: 'white',
                    transition: '.2s'
                },
            }
        },
    };

    function renderLoading() {
        return (
            <div className="center-page">
                <Spinner animation="border" />
            </div>
        )
    }

    async function init() {
        setLoading(true)
        const response = await getUsers();
        if (response !== null) {
            const data = response.data;
            setBeacons(data);

            setTableData({
                data,
                columns
            })
        }
        setLoading(false);
    }

    async function getUsers() {
        try {
            const response = await client.get(`/api/users-by-client/${client_id}`);
            return response;
        } catch (e) {
            console.log(e);
        }
        return null;
    }

    return (
        <div className="AccountUsersScreen sidenav-margin">
            <AresNavBar />
            <SideBar />

            <div className="content">
                <div>
                    <div className="container-header">
                        <h1>Usuários</h1>
                    </div>

                </div>
                {loading ?
                    renderLoading()
                    :
                    <div>
                        <div className="beacon-table">
                            <DataTableExtensions
                                {...tableData}
                                filterPlaceholder="Pesquisar dispositivos"
                                print={false}>
                                <DataTable
                                    columns={columns}
                                    data={beacons}
                                    noDataComponent={
                                        <span>Nada encontrado...</span>
                                    }
                                    pagination={true}
                                    customStyles={customStyles}
                                />
                            </DataTableExtensions>
                        </div>
                    </div>
                }
            </div>
        </div>

    );
}

export default AccountUsers;